import React, { useEffect, useLayoutEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { RangeDatePicker } from '../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import { useQuery } from '../../../../utils/hooks/useQuery';
import Button from '../../../_common/Form/Buttons/Button';
import classes from './noteCount.module.scss';
import utils from '../../../../utils/utils';
import { getDashboardNoteCountRequest } from '../../../../store/actions/dashboard';
import Loader from '../../../_common/Loader/Loader';
import TableAndPagination from '../../../_common/TableAndPagination/TableAndPagination';

const tableHeader = [
  {
    name: 'Name',
    path: 'name',
  },
  {
    name: 'Count',
    path: 'noteCount',
  },
  // {
  //   name: 'Script id',
  //   path: 'scriptId',
  // },
];

const collectRequestData = (requestData) => {
  const data = utils.deleteEmptyKeys(requestData);

  if (data.start) {
    if (!data.end) {
      data.end = moment(data.start).format('YYYY-MM-DD');
    } else {
      data.end = moment(data.end).format('YYYY-MM-DD');
    }
  }

  return data;
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');

const NoteCount = () => {
  const { query, setQuery } = useQuery();
  const dispatch = useDispatch();
  const { dashboardNoteCountData } = useSelector((store) => store.dashboard);

  const [requestData, setRequestData] = useState({
    start: query.start || thisMonthStartDay,
    end: query.start && !query.end ? '' : thisMonthEndDate,
  });

  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    (async () => {
      await dispatch(getDashboardNoteCountRequest(collectRequestData(requestData)));
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    const newQuery = utils.deleteEmptyKeys({ ...requestData });
    setQuery(newQuery);
  }, [requestData]);

  const onChangeDate = async (currentDate) => {
    setLoading(true);
    setRequestData((prev) => ({ ...prev, start: currentDate[0], end: currentDate[1] }));

    const data = collectRequestData({ ...requestData, start: currentDate[0], end: currentDate[1] });

    await dispatch(getDashboardNoteCountRequest(data));
    setLoading(false);
  };

  const clearFilters = async () => {
    setLoading(true);

    const defaultRequestData = {
      start: thisMonthStartDay,
      end: thisMonthEndDate,
    };

    setRequestData(defaultRequestData);

    await dispatch(getDashboardNoteCountRequest(defaultRequestData));

    setLoading(false);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.wrapper_header}>
        <div style={{ marginRight: 10 }}>
          <RangeDatePicker
            currentDate={requestData}
            onChangeDate={onChangeDate}
            showLastYear
          />
        </div>

        <div className={classes.button_wrapper}>
          <Button
            title="Clear"
            clearButton
            onClick={clearFilters}
          />
        </div>
      </div>

      <div className={classes.table_wrapper}>
        {loading
          ? <Loader />

          : (
            <TableAndPagination
              data={dashboardNoteCountData}
              header={tableHeader}
              hidePagination
            />
          )}
      </div>
    </div>
  );
};

export default NoteCount;
